export const fontStyle = ({ italic = false }) => (italic ? 'italic' : 'normal');
export const textDecoration = ({ underline = false }) =>
  underline ? 'underline' : 'none';
export const textTransform = ({ textTransform = false }) =>
  textTransform ? textTransform : 'none';

export const wrap = maxWidth => {
  const [min, max] = Array.isArray(maxWidth)
    ? maxWidth
    : [null, maxWidth === true ? null : maxWidth];
  return `
    white-space: pre-wrap;
    max-width: ${max || 'initial'};
    min-width: ${min || 'initial'};
  `;
};
